import { render, staticRenderFns } from "./StudentEdit.vue?vue&type=template&id=4dfd0e03&scoped=true&"
import script from "./StudentEdit.vue?vue&type=script&lang=js&"
export * from "./StudentEdit.vue?vue&type=script&lang=js&"
import style0 from "./StudentEdit.vue?vue&type=style&index=0&id=4dfd0e03&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfd0e03",
  null
  
)

export default component.exports